<template>
  <nav>
    <v-app-bar
      app
      dark
      color="primary"
      style="left: 0 !important; width: 100% !important"
    >
      <v-img
        :src="images.ecozenWhite"
        class="ml-14"
        max-height="40"
        max-width="100"
        contain
      ></v-img>
      <span class="ml-4 caption white--text">{{ deployedAt }}</span>
      <v-spacer />
      <search-menu class="mx-3" />
    </v-app-bar>
    <v-navigation-drawer
      app
      dark
      color="secondary"
      permanent
      :mini-variant="isMini"
      mini-variant-width="56"
      @mouseenter.native="isMini = false"
      @mouseleave.native="isMini = true"
    >
      <v-layout column fill-height>
        <v-list dense nav>
          <v-list-item two-line class="px-0">
            <v-list-item-avatar>
              <img
                src="https://api.ecozen.ai/dashboard/assets/images/logos/icon_white.png"
              />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="title pb-1">
                {{ user.name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ user.portal }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item to="/" exact>
            <v-list-item-icon>
              <v-icon>mdi-gauge</v-icon>
            </v-list-item-icon>
            <v-list-item-title>List of Devices</v-list-item-title>
          </v-list-item>
          <v-list-item to="/mqtt" v-if="displayOnHome" exact>
            <v-list-item-icon>
              <v-icon>mdi-radio-tower</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Mqtt Multi-devices</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item to="/fota" v-if="displayOnHome" exact>
            <v-list-item-icon>
              <v-icon>mdi-update</v-icon>
            </v-list-item-icon>
            <v-list-item-title>FOTA</v-list-item-title>
          </v-list-item> -->
          <v-list-item to="/schedule-mqtt" v-if="displayOnHome" exact>
            <v-list-item-icon>
              <v-icon>mdi-calendar-arrow-right</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Schedule Mqtt</v-list-item-title>
          </v-list-item>
          <v-list-group
            :prepend-icon="selectedMachine.icon"
            value="true"
            no-action
            v-if="selectedMachine.display"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title
                  v-text="selectedMachine.machineId"
                ></v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item :to="selectedMachine.dashboardLink" exact class="px-2">
              <v-list-item-icon>
                <v-icon>mdi-monitor-dashboard</v-icon>
              </v-list-item-icon>
              <v-list-item-title> Dashboard </v-list-item-title>
            </v-list-item>
            <v-list-item :to="selectedMachine.profileLink" exact class="px-2">
              <v-list-item-icon>
                <v-icon>mdi-cog-box</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Device Profile</v-list-item-title>
            </v-list-item>
            <v-list-item :to="selectedMachine.mqttLink" exact class="px-2">
              <v-list-item-icon>
                <v-icon>mdi-access-point</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Mqtt</v-list-item-title>
            </v-list-item>
            <v-list-item :to="selectedMachine.tableLink" exact class="px-2">
              <v-list-item-icon>
                <v-icon>mdi-table</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Data table</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list>
        <v-spacer></v-spacer>
        <v-list dense class="py-2" nav>
          <v-list-item href="https://ecozen.ai" target="_blank">
            <v-list-item-icon>
              <v-icon>mdi-link</v-icon>
            </v-list-item-icon>
            <v-list-item-title> EZ Version 2.2.0</v-list-item-title>
          </v-list-item>
          <v-list-item href="https://www.ecozensolutions.com" target="_blank">
            <v-list-item-icon>
              <v-icon>mdi-earth</v-icon>
            </v-list-item-icon>
            <v-list-item-title> Visit Our Website</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title> Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-layout>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import SearchMenu from './SearchMenu.vue';
export default {
  name: 'navbar',
  components: {
    SearchMenu
  },
  data: () => ({
    isMini: true,
    deployedAt: 'Deployed : 12-08-2026, 2:45 PM',
    images: {
      ecozenWhite:
        'https://api.ecozen.ai/dashboard/assets/images/logos/ecozen_white.png'
    }
  }),
  computed: {
    selectedMachine() {
      let route = this.$route.name;
      let machineId = this.$route.params.topic;
      if (route === null) {
        return { display: false };
      } else {
        if (route.includes('ecotron')) {
          return {
            dashboardLink: `/ecotron/${machineId}`,
            profileLink: `/ecotron/${machineId}/profile`,
            mqttLink: `/ecotron/${machineId}/mqtt`,
            tableLink: `/ecotron/${machineId}/table`,
            display: true,
            machineId,
            icon: 'mdi-water-pump'
          };
        } else if (route.includes('ecofrost')) {
          return {
            dashboardLink: `/ecofrost/${machineId}`,
            profileLink: `/ecofrost/${machineId}/profile`,
            mqttLink: `/ecofrost/${machineId}/mqtt`,
            tableLink: `/ecofrost/${machineId}/table`,
            display: true,
            machineId,
            icon: 'mdi-snowflake'
          };
        } else {
          return { display: false };
        }
      }
    },
    displayOnHome() {
      let route = this.$route.name;
      if (
        route === 'home' ||
        route === 'fota' ||
        route === 'mqtt-multiple-devices' ||
        route === 'schedule-mqtt'
      ) {
        return true;
      } else {
        return false;
      }
    },
    user() {
      return this.$store.state.user.user;
    }
  },
  methods: {
    async logout() {
      this.$store.dispatch('user/logout');
    }
  }
};
</script>
